<template>
  <div class="empty-content">

    <p>{{title}}</p>

    <slot name="content"></slot>

  </div>
</template>

<script>
export default {
  props: {
    title: {
      required: true
    },

  }
}
</script>

<style lang="scss">
.empty {
  width: 100%;
  height: 100%;
  max-height: 100vh;
  &.hidden {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.empty-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
  width: 100%;
  height: 100%;
  p {

  }

}
</style>
